/**
 * @Author: v_jppjpeng
 * @Date: 2024-11-08 17:47:59
 * @Explain: 周期活动
 */

export default {
  // 周期提交确认框
  'CYCLE.ACTIVITY.CYCLE.SUBMIT.CONFIRM.LATEST.CYCLE':
    'The next cycle is cycle {latestCycle}.',
  'CYCLE.ACTIVITY.CYCLE.SUBMIT.CONFIRM.REPLACEMENT.DESC1':
    'The delivery times for <b class="color-333">cycles {letSlipCycle}</b> have already passed。',
  'CYCLE.ACTIVITY.CYCLE.SUBMIT.CONFIRM.REPLACEMENT.DESC2':
    'The delivery times for <b class="color-333">cycles {letSlipCycle}</b> have already passed, do you want to resend <b class="color-333">cycle {reissueCycle}</b>。',
  'CYCLE.ACTIVITY.CYCLE.REISSUE.INSTRUCTIONS':
    "The next cycle's delivery time is more than {num} hours hours ahead. You can resend the last cycle immediately.",
  'CYCLE.ACTIVITY.IMMEDIATE.REPLACEMENT': 'Resend immediately',
  'CYCLE.ACTIVITY.NEXT.SETTING': 'Continue',

  // 列表
  'CYCLE.ACTIVITY.LIST.DETAILS': 'Cycle details',

  // 周期列表 - 开始
  'CYCLE.ACTIVITY.LIST.ACTION.START.TITLE': 'Restart campaign?',
  'CYCLE.ACTIVITY.LIST.ACTION.START.DESC':
    'After restarting this campaign, emails will be sent according to any adjustments made. ',

  // 周期详情
  'CYCLE.ACTIVITY.LIST.TIME.LINE.CYCLE.DETAILS.START.AND.ENDS':
    'Cycle duration: ',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.CYCLE.DETAILS.SENDER': 'Recipients: ',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO':
    '<span class="color-666"> changed from <span class="color-333">{old}</span> to <span class="color-333">{new}</span></span>',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.SEND.TIME': 'Delivery time',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.SEND.TIME.FIXED':
    'Global fixed time at',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.SEND.TIME.BEST':
    'Optimal Sending Time',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.SEND.TIME.LOCAL':
    'Region Fixed Time at ',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.SENDER': 'Recipients',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.SENDER.TAG': 'Tag',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.SENDER.SEGMENT': 'Segment',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.SENDER.SUBSCRIBE':
    'Subscription status',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.TEMPLATE': 'Email template',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.CYCLE.START.TIME':
    'Cycle start time changed from ',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.CYCLE.END.TIME': 'Cycle end time',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.CYCLE.FREQUENCY':
    'Delivery frequency',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.CYCLE.FREQUENCY.DAY': 'Send daily',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.CYCLE.FREQUENCY.WEEK':
    'Every {str}',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.CYCLE.FREQUENCY.MONTH':
    'Send monthly (on {str})',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.DUPLICATE.REMOVAL':
    'Email frequency controls',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.DUPLICATE.REMOVAL.ISNOREPETITION.0':
    'No limit',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.DUPLICATE.REMOVAL.ISNOREPETITION.1':
    'Limited',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.DUPLICATE.REMOVAL.ISREMOVEPERMANCENT.1':
    'Never limited',
  'CYCLE.ACTIVITY.LIST.TIME.LINE.UPDATE.INFO.DUPLICATE.REMOVAL.ISREMOVEPERMANCENT.2':
    'Limited within {num} days ',

  // 创建

  // 创建周期 - 发布提醒
  'CYCLE.ACTIVITY.POST.A.REMINDER': 'Launch notice',
  'CYCLE.ACTIVITY.POST.A.REMINDER.DESC1':
    "After launching this campaign, its delivery will start at the next cycle's start time.",

  // 创建周期 - 发送给
  'CYCLE.ACTIVITY.EXPECTED.DELIVERY.DAYS1':
    '<b class="font-poppins">{num}days</b> expected time for delivering all emails in this cycle.',

  // 创建周期 - 选择内容
  'CYCLE.ACTIVITY.LANGUAGE.SETTING': 'Select languages',
  'CYCLE.ACTIVITY.SEARCH.LANGUAGE': 'Search language',
  'CYCLE.ACTIVITY.SELECT.LANGUAGE.TIPS':
    'Add/remove additional languages that are not part of the first cycle.',

  // 创建周期 - 时间计划
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE.DATE.LABEL': 'Cycle duration',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.START.AT': 'Starts at',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.END.AT': 'Ends at',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE.FREQUENCY.LABEL': 'Delivery frequency',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE.FREQUENCY.PLACEHOLDER':
    'Select Delivery frequency',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.SENDING.TIME.LABEL': 'Delivery time',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.PLEASE.FIXED.TIME':
    'Select global delivery time',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.PLEASE.LOCAL.TIME':
    'Select local delivery time',

  'CYCLE_ACTIVITY.SCHEDULE.TIME.RANGE.TITLE': 'Time adjustment scope',
  'CYCLE_ACTIVITY.SCHEDULE.TIME.RANGE.REMINDER':
    'Confirm the scope of your delivery time adjustment. The new delivery times of each cycle can be viewed in the cycle details.',

  'CYCLE_ACTIVITY.SCHEDULE.TIME.RANGE.LOGIC.1':
    'Adjust all cycles after restarting campaign',
  'CYCLE_ACTIVITY.SCHEDULE.TIME.RANGE.LOGIC.2':
    'Adjust only the first cycle after restarting campaign',

  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE_FREQUENCY_MONDAY': 'Monday',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE_FREQUENCY_TUESDAY': 'Tuesday',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE_FREQUENCY_WEDNESDAY': 'Wednesday',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE_FREQUENCY_THURSDAY': 'Thursday',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE_FREQUENCY_FRIDAY': 'Friday',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE_FREQUENCY_SATURDAY': 'Saturday',
  'CYCLE.ACTIVITY.CREATE.SCHEDULE.CYCLE_FREQUENCY_SUNDAY': 'Sunday',

  'CYCLE_ACTIVITY.CREATE_SCHEDULE.CYCLE_DAY_PREFIX': 'Day {day}',

  // 审批周期 - 审批提醒
  'CYCLE.ACTIVITY.APPROCAL.TITLE': 'Approval notice',
};
